/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExpiredEmployeeDashboardApiModel } from './expiredEmployeeDashboardApiModel';


export interface EmployerDashboardApiModel { 
    employeesCount: number;
    eligibleEmployeesCount: number;
    eligibleEmployeesPlanedCount: number;
    soonExpiredEmployeesCount: number;
    soonExpiredEmployeesPlanedCount: number;
    expiredEmployeesCount: number;
    expiredEmployeesPlanedCount: number;
    subsetExpiredEmployees: Array<ExpiredEmployeeDashboardApiModel>;
}

